import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { ActiveCategorySwitch, TableCell, ModalRef } from "@shared/components";

export const useCategoryListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  categoryModalRef: RefObject<ModalRef>,
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("category_admin.fields.id"),
        width: 80,
      },
      {
        field: "name",
        headerName: translate("category_admin.fields.name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "companies",
        headerName: translate("category_admin.fields.companies"),
        minWidth: 120,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="right"
          />
        ),
      },
      {
        field: "usage",
        headerName: translate("category_admin.fields.usage"),
        minWidth: 120,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="right"
          />
        ),
      },
      {
        field: "total_transacted",
        headerName: translate("category_admin.fields.total_transacted"),
        minWidth: 120,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value ? `R$ ${parseFloat(value).toFixed(2)}` : value}
            textAlign="right"
          />
        ),
      },
      {
        field: "active",
        headerName: translate("category_admin.fields.active"),
        minWidth: 150,
        headerAlign: "center",
        renderCell: ({ value, row }) => (
          <TableCell.Container align="center">
            <ActiveCategorySwitch value={value} id={row.id} />
          </TableCell.Container>
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        display: "flex",
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => categoryModalRef.current?.open(row)}
            />

            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, categoryModalRef],
  );
};
